'use client';

import React from 'react';

import Head from 'next/head';

import { SeoCardProps } from './types';

const SeoCard: React.FC<SeoCardProps> = ({ generalCard, openGraphCard }) => {
  if (!generalCard && !openGraphCard) {
    return null;
  }

  return (
    <Head>
      {generalCard?.disableIndexing && (
        <meta key="robots" content="noindex" name="robots" />
      )}
      {generalCard?.title && <title>{generalCard.title}</title>}
      {generalCard?.description && (
        <meta
          key="description"
          content={generalCard.description}
          name="description"
        />
      )}
      {generalCard?.canonical && (
        <link key="canonical" href={generalCard.canonical} rel="canonical" />
      )}

      {openGraphCard?.title && (
        <meta
          key="og:title"
          content={openGraphCard.title}
          property="og:title"
        />
      )}
      {openGraphCard?.description && (
        <meta
          key="og:description"
          content={openGraphCard.description}
          property="og:description"
        />
      )}
      {openGraphCard?.type && (
        <meta key="og:type" content={openGraphCard.type} property="og:type" />
      )}
      {openGraphCard?.imageUrl && (
        <>
          <meta
            key="og:image"
            content={openGraphCard.imageUrl}
            property="og:image"
          />
          <meta
            key="og:image:secure_url"
            content={openGraphCard.imageUrl}
            property="og:image:secure_url"
          />
          {openGraphCard.imageAlt && (
            <meta
              key="og:image:alt"
              content={openGraphCard.imageAlt}
              property="og:image:alt"
            />
          )}
        </>
      )}
    </Head>
  );
};

export default SeoCard;
